import BootstrapTooltip from "@/react/bootstrap/components/BootstrapTooltip";
import UiBtnGroup from "@/react/story/components/ui/UiBtnGroup";
import UiDropzone from "@/react/story/components/ui/UiDropzone";
import UiInput from "@/react/story/components/ui/UiInput";
import { type Font, FontFormatEnum, FontWeightEnum } from "@/react/story/types";
import { type FormEvent, useId, useState } from "react";

type Props = {
    font: Font;
    onSave: (font: Font) => void;
    onDelete: (font: Font) => void;
    onCancel: () => void;
}

export default function NavFontsCreate(props: Props) {
    const [ font, setFont ] = useState<Font>(props.font);
    const fontId = useId();
    const familyId = useId();
    const formatId = useId();
    const weightsId = useId();

    const handleSave = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        props.onSave(font);
    };

    const handleDelete = () => {
        props.onDelete(font);
    };

    const handleCancel = () => {
        props.onCancel();
    };

    return (
        <form onSubmit={handleSave} className="d-flex flex-column gap-3 mb-3">
            <div>
                <label className="d-block" htmlFor={fontId}>Fichier/URL*</label>
                <UiDropzone
                    defaultValue={font.font}
                    acceptedFiles=".woff,.woff2,font/woff,font/woff2,font/*"
                    icon="filetype-woff"
                    onChange={font => setFont(p => ({ ...p, font }))}
                />
            </div>
            <div>
                <label className="d-block" htmlFor={familyId}>Famille*</label>
                <div className="input-group">
                    <div className="input-group-text"><span className="bi-alphabet-uppercase"></span></div>
                    <UiInput<string>
                        required
                        defaultValue={font.family}
                        onChange={family => setFont(p => ({ ...p, family: family ?? "" }))}
                    />
                </div>
            </div>
            <div>
                <label className="d-block" htmlFor={formatId}>Format*</label>
                <select id={formatId} required className="form-select" value={font.format} onChange={e => {
                    const format = Object.values(FontFormatEnum).find(v => v === e.target.value);
                    if (format) {
                        setFont(p => ({ ...p, format }));
                    }
                }}>
                    {Object.values(FontFormatEnum).map(format => (
                        <option key={format} value={format}>{format}</option>
                    ))}
                </select>
            </div>
            <div>
                <label className="d-block" htmlFor={weightsId}>Graisses*</label>
                <UiBtnGroup
                    items={FontWeightEnum.map(w => ({ label: w, value: w }))}
                    isActive={e => font.weights.includes(e)}
                    set={w => setFont(p => ({
                        ...p,
                        weights: p.weights.includes(w) ? p.weights.filter(v => v !== w) : [ ...p.weights, w ],
                    }))}
                />
            </div>
            <div className="d-flex justify-content-between gap-3">
                <button type="button" className="btn btn-outline-secondary" onClick={handleCancel}>
                    Annuler
                </button>
                <BootstrapTooltip title="Supprimer">
                    <button type="button" className="btn btn-outline-danger" onClick={handleDelete}>
                        <span className="bi-trash"></span>
                    </button>
                </BootstrapTooltip>
                <BootstrapTooltip title="Enregistrer">
                    <button className="btn btn-outline-primary">
                        <span className="bi-floppy"></span>
                    </button>
                </BootstrapTooltip>
            </div>
        </form>
    );
}
